import { useGeoLookupContext } from '@/hooks/useGeoLookupContext';
import { config } from '@/pageConfig/car/pay-per-mile/us/en';
import { CarPageTemplate } from '@/pageTemplate/CarPageTemplate';
import { useEffect } from 'react';

export default function CarPayPerMilePage() {
  const { trackEventWithGeolocation } = useGeoLookupContext();
  // biome-ignore lint/correctness/useExhaustiveDependencies: want to track event only once
  useEffect(
    () =>
      trackEventWithGeolocation('car_page.viewed', {
        variant: 'default',
        priceType: 'ppm',
      }),
    [],
  );

  return <CarPageTemplate config={config} isNjEnabled={false} priceType="ppm" />;
}
